module.exports = __webpack_public_path__ + "img/faq5_2.de29d281.png";